module.exports = function(red, green, blue){
    this.red = red;
    this.green = green;
    this.blue = blue;
};



// WEBPACK FOOTER //
// ./lib/data/rgb.js